import { Helmet } from 'react-helmet-async';
import KeywordBased from 'src/sections/overview/dashboards/views/keywordBased';

export default function BrandShieldKoBiddingManualTroas() {
  return (
    <>
      <Helmet>
        <title>Target ROAS</title>
      </Helmet>

      <KeywordBased />
    </>
  );
}
